import { Fragment } from 'react';
import clsx from 'clsx';
import { useCalendarContext } from '@/components/calendar/context';
import { isCalendarDayEqualsToDate } from '@/components/calendar/utils';
import Time from '@/utils/time';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/calendar/components/day/day-v1.css';
import '@/components/calendar/components/day/day-v2.css';

export default function Day() {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { date, dayNames, calendarData, onCalendarClick } = useCalendarContext();

  return (
    <Fragment>
      <div data-css-version={cssVersion} className='calendar-day-names'>
        {dayNames.map((dayName, i) => (
          <div key={i} className='calendar-day-name'>
            {dayName}
          </div>
        ))}
      </div>
      {calendarData.map((week, weekIndex) => (
        <div key={weekIndex} data-css-version={cssVersion} className='calendar-week'>
          {week.map((calendarDay, dayIndex) => (
            <button
              key={dayIndex}
              type='button'
              disabled={calendarDay.outOfPeriod}
              className={clsx('calendar-day', {
                'calendar-day--out-of-period': calendarDay.outOfPeriod,
                'calendar-day--not-from-this-month': calendarDay.notThisMonth,
                'calendar-day--today': isCalendarDayEqualsToDate(calendarDay, new Date()),
                'calendar-day--selected': isCalendarDayEqualsToDate(calendarDay, date),
              })}
              onClick={() => onCalendarClick(Time.date(calendarDay.day, calendarDay.month, calendarDay.year))}
            >
              {calendarDay.day}
            </button>
          ))}
        </div>
      ))}
    </Fragment>
  );
}
